class ShowMoreContent {
  constructor({btnSelector, contentSelector}) {
    this.btnElement = document.querySelector(btnSelector);
    this.contentElement = document.querySelector(contentSelector);

    if (this.btnElement && this.contentElement) {
      this.#addListeners();
    }
  }

  #showMoreContent() {
    const elements = this.contentElement.children;

    for (let element of elements) {
      element.style.display = "";
    }

    this.btnElement.remove();
  }

  onBtnClick() {
    this.#showMoreContent();
  }

  #addListeners() {
    this.onBtnClick = this.onBtnClick.bind(this);

    this.btnElement.addEventListener("click", this.onBtnClick, {once: true});
  }
}

export default ShowMoreContent;
